import o from "./generateUtilityClasses.mjs";
import r from "./generateUtilityClass.mjs";
function i(t) {
  return r("MuiAccordionSummary", t);
}
const e = o("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), n = e;
export {
  n as default,
  i as getAccordionSummaryUtilityClass
};
//# sourceMappingURL=accordionSummaryClasses.mjs.map
